import React,{Component} from "react";
import Grid from '@material-ui/core/Grid';
import { NotificationManager } from 'react-notifications';
import { withStyles } from '@material-ui/core/styles';
import {UserContext} from "../../context/UserContext";
import Container from '@material-ui/core/Container';
import ExpensesList from '../../components/ExpensesList';
import ReplenishmentList from '../../components/ReplenishmentList';
import MyAccountsList from '../../components/MyAccountsList';
import TariffsList from '../../components/TariffsList';
import TopUpBalance from '../../components/TopUpBalance';
import {StyledTableCell, StyledTableRow, useStyles} from './styles';
import apiStore from '../../store/ApiStore';
import Client from '../../store/Model/Client';
import 'moment/locale/ru';
import {Trans} from "react-i18next";
import BarChart from "../../components/shared/BarChart/BarChart";
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import CurrencyDollarsIcon from '@mui/icons-material/AttachMoney';
import CurrencyEuroIcon from '@mui/icons-material/Euro';
import Popover from "@material-ui/core/Popover/Popover";
import Card from "@material-ui/core/Card/Card";
import {Link} from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import AddCardIcon from '@mui/icons-material/AddCard';
import userStore from "../../store/UserStore";
import Rus from "../PrivacyPolicy/Rus";
import Button from "@material-ui/core/Button";

// moment.locale('ru');

const listCurrencies = [
    { name: 'RUBLE', uid: "68377f72-363c-11f0-828a-00163cd7dafc" },
    { name: 'EURO', uid: "0f83379e-363d-11f0-828a-00163cd7dafc" },
    { name: 'DOLLAR', uid: "096d1f8c-363d-11f0-828a-00163cd7dafc" },
];

class Balance extends Component{

    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            arClients: [],
            selectUser: null,
            page: 0,
            pageSize: 10,
            enroll: [],
            listBalances: []
        };
    }

    loadBalance = async () => {
    //    await apiStore.getClients(0, 100).then(data => data.data).then(data => data.map(val=>new Client(val))).then(data => this.setState({arUsers: data}));
       await apiStore.getListBalances().then(data => {
           this.setState({listBalances: data});
           console.log("loadBalance, data: ", data);
       });
   };

    componentDidMount() {
        this.loadBalance();
    }

    handleMenuExpenses = (event) => {
        console.log("handleMenuExpenses");
        this.setState({tabIndex: 0});
        // check current balance
        this.loadBalance();
    };
    handleMenuReplenishment = (event) => {
        console.log("handleMenuReplenishment");
        this.setState({tabIndex: 1});
        // check current balance
        this.loadBalance();
    };
    handleMenuMyAccounts = (event) => {
        console.log("handleMenuMyAccounts");
        this.setState({tabIndex: 2});
        // check current balance
        this.loadBalance();
    };
    handleMenuTariffs = (event) => {
        console.log("handleMenuTariffs");
        this.setState({tabIndex: 3});
        // check current balance
        this.loadBalance();
    };
    handleMenuReplenish = (event) => {
        console.log("handleMenuReplenish");
        this.setState({tabIndex: 4});
        // check current balance
        this.loadBalance();
    };

    render() {
        let self = this;
        return <UserContext.Consumer>
            {
                ({user}) => self._render()
            }
        </UserContext.Consumer>;
    }

    _render() {
        const { classes } = this.props;

        return (<div className={classes.root} >
            <h2 style={{marginTop: 5, marginBottom: 5, marginLeft: 30}}>
                <Trans i18nKey={"Payment"} >{"Payment"}</Trans>
            </h2>
            <Container className={"dashboardPage"}>
                <Grid container spacing={3} style={{
                    marginTop: 0
                }}>
                    <Grid item xs={12} md={2} lg={2} >
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12} lg={12} >
                                <div className={classes.block} >
                                    <h3 style={{marginLeft: 5, marginBottom: 10}}>
                                        <Trans i18nKey={"Balance"} >{"Balance"}</Trans>
                                    </h3>
                                    {this.state.listBalances.map((val) => {
                                        return (
                                            <h3 style={{marginLeft: 17}}>
                                                {Number.parseFloat(val.balance).toFixed(2)}
                                                {val.payment_currency_u === listCurrencies[0].uid ? (
                                                    <CurrencyRubleIcon fontSize="small" style={{marginBottom: -3}} />
                                                ) : val.payment_currency_u === listCurrencies[1].uid ? (
                                                    <CurrencyEuroIcon fontSize="small" style={{marginBottom: -3}} />
                                                ) : val.payment_currency_u === listCurrencies[2].uid ? (
                                                    <CurrencyDollarsIcon fontSize="small" style={{marginBottom: -3}} />
                                                    ) : ("")}
                                            </h3>
                                        )})
                                    }
                                </div>
                            </Grid>
                            <Grid item xs={12} md={12} lg={12} >
                                <Card className={classes.menu} >
                                    <MenuItem onClick={this.handleMenuExpenses} >
                                        <Typography variant="inherit" style={{display: 'block', width: 140}}>
                                            <Trans i18nKey={"Expenses"} >{"Expenses"}</Trans>
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem onClick={this.handleMenuReplenishment} >
                                        <Typography variant="inherit" style={{display: 'block', width: 140}}>
                                            <Trans i18nKey={"Replenishment"} >{"Replenishment"}</Trans>
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem onClick={this.handleMenuMyAccounts} >
                                        <Typography variant="inherit" style={{display: 'block', width: 140}}>
                                            <Trans i18nKey={"MyAccounts"} >{"MyAccounts"}</Trans>
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem onClick={this.handleMenuTariffs} >
                                        <Typography variant="inherit" style={{display: 'block', width: 140}}>
                                            <Trans i18nKey={"Tariffs"} >{"Tariffs"}</Trans>
                                        </Typography>
                                    </MenuItem>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={12} lg={12} >
                                <div className={classes.menu} >
                                    <MenuItem onClick={this.handleMenuReplenish} >
                                        <Typography variant="inherit" style={{display: 'block', width: 140}}>
                                            <Trans i18nKey={"Replenish"} >{"Replenish"}</Trans>
                                        </Typography>
                                    </MenuItem>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={10} lg={10} >
                        {this.state.tabIndex === 0 ? (
                            <Grid container spacing={0} style={{}} >
                                <Grid item xs={12} md={12} lg={12} style={{backgroundColor: '#fff',
                                    paddingTop: 24,
                                    paddingBottom: 54,
                                    paddingLeft: 12,
                                    paddingRight: 12}}
                                >
                                    <ExpensesList
                                        onSelectUser={async (data) => {
                                            let uid = data.user_u;//data.pop();
                                            let client = [];
                                            let enrol = [];
                                            this.setState({select: data, enrol: enrol});
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        ) : this.state.tabIndex === 1 ? (
                            <Grid container spacing={0} style={{}} >
                                <Grid item xs={12} md={12} lg={12} style={{backgroundColor: '#fff',
                                    paddingTop: 24,
                                    paddingBottom: 54,
                                    paddingLeft: 12,
                                    paddingRight: 12}}
                                >
                                    <ReplenishmentList
                                        onSelectUser={async (data) => {
                                            let uid = data.user_u;//data.pop();
                                            let client = [];
                                            let enrol = [];
                                            this.setState({select: data, enrol: enrol});
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        ) : this.state.tabIndex === 2 ? (
                            <Grid container spacing={0} style={{}} >
                                <Grid item xs={12} md={12} lg={12} style={{backgroundColor: '#fff',
                                    paddingTop: 24,
                                    paddingBottom: 54,
                                    paddingLeft: 12,
                                    paddingRight: 12}}
                                >
                                    <MyAccountsList
                                        onSelectUser={async (data) => {
                                            let uid = data.user_u;//data.pop();
                                            let client = [];
                                            let enrol = [];
                                            this.setState({select: data, enrol: enrol});
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        ) : this.state.tabIndex === 3 ? (
                                <Grid container spacing={0} style={{}} >
                                    <Grid item xs={12} md={12} lg={12} style={{backgroundColor: '#fff',
                                        paddingTop: 24,
                                        paddingBottom: 54,
                                        paddingLeft: 12,
                                        paddingRight: 12}}
                                    >
                                        <TariffsList
                                            onSelectUser={async (data) => {
                                                let uid = data.user_u;//data.pop();
                                                let client = [];
                                                let enrol = [];
                                                this.setState({select: data, enrol: enrol});
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                        ) : (
                            <Grid container spacing={0} style={{}} >
                                <Grid item xs={12} md={12} lg={12} style={{backgroundColor: '#fff',
                                    paddingTop: 24,
                                    paddingBottom: 54,
                                    paddingLeft: 12,
                                    paddingRight: 12}}
                                >
                                    <TopUpBalance
                                        onSelectUser={async (data) => {
                                            let uid = data.user_u;//data.pop();
                                            let client = [];
                                            let enrol = [];
                                            this.setState({select: data, enrol: enrol});
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Container>
        </div>);
    }
}

export default withStyles(useStyles)(Balance)
